<template>
  <div v-if="$store.getters.token">
    <ul class="kyc-tab-frame-m">
      <li class="tab-items-m verify-tab-items-m " @click="$router.push('/user/edit')">
        <i class="icon-arrow-back">
          <img :src="getThemeImagePath('home-arrow-left.png')" alt="">
        </i>
        {{ $t("Bao.return_user_page") }}
      </li>
    </ul>
    <!-- 驗證審核中 -->
    <div v-if="memberInfo.is_pass_KYC===2" class="verify-form">
      <p>
        <i class="icon-alert ">
          <img :src="getThemeImagePath('icon-alert-kyc.png')" alt="">
        </i>
        <span>{{ $t("Bao.kyc_verifydetail") }}</span>
        <br>
        <span>
          {{ $t("Bao.kyc_already") }}<span class="highlight"> {{ $t("Bao.kyc_audit") }}</span>。
        </span>
      </p>
    </div>
    <!-- 已驗證 -->
    <div v-if="memberInfo.is_pass_KYC===1" class="verify-form">
      <p>
        <i class="icon-alert "><img :src="getThemeImagePath('icon-alert-kyc.png')" alt=""></i>
        <span>{{ $t("Bao.kyc_verifydetail") }}</span>
        <br>
        <span>
          {{ $t("Bao.kyc_already") }}<span class="highlight"> {{ $t("Bao.kyc_pass_verify") }}</span>。
        </span>
      </p>
    </div>
    <!-- 未經過驗證 -->
    <div v-if="memberInfo.is_pass_KYC===0" class="verify-form">
      <p>
        <i class="icon-alert "><img :src="getThemeImagePath('icon-alert-kyc.png')" alt=""></i>
        <span>{{ $t("Bao.kyc_verifydetail") }}</span>
        <br>
        <span>
          {{ $t("Bao.kyc_already") }}<span class="highlight"> {{ $t("Bao.kyc_upload_docs") }}</span>。
        </span>
      </p>
    </div>
    <br>

    <div class="kyc-bg">
      <div class="kyc-item unverified toggle" :class="{ active: activeItems['item1'], 'hide-h5': hideIdentity }">
        <h5 @click="toggleItem('item1')">
          {{ $t("Bao.kyc_idcard") }}
        </h5>

        <div class="kyc-content">
          <p>
            {{ $t("Bao.kyc_upload_below") }}
            <span class="highlight">{{ $t("Bao.kyc_oneof") }}</span>
            {{ $t("Bao.kyc_docs") }}
          </p>
          <div class="kyc-ex-pic-frame">
            <img :src="getThemeImagePath('my_kyc_ex1.png')" alt="">
          </div>
          <div class="kyc-btn-group-frame">
            <div class="btn-frame">
              <button class="btn uploadPic JQellipsis" @click="setKYCUrl('Identity', 'driver')">
                {{ $t("Bao.driver_selfie") }}
              </button>
            </div>
            <div class="btn-frame">
              <button class="btn uploadPic JQellipsis" @click="setKYCUrl('Identity', 'numcard')">
                {{ $t("Bao.numcard_selfie") }}
              </button>
            </div>
            <div class="btn-frame">
              <button class="btn uploadPic JQellipsis" @click="setKYCUrl('Identity', 'passport')">
                {{ $t("Bao.passport_selfie") }}
              </button>
            </div>
            <div class="btn-frame">
              <button class="btn uploadPic JQellipsis" @click="setKYCUrl('Identity', 'debtcard')">
                {{ $t("Bao.debtcard_selfie") }}
              </button>
            </div>
            <div class="btn-frame">
              <button class="btn uploadPic JQellipsis" @click="setKYCUrl('Identity', 'esidentcard')">
                {{ $t("Bao.esidentcard_selfie") }}
              </button>
            </div>
            <div class="btn-frame">
              <button class="btn uploadPic JQellipsis" @click="setKYCUrl('Identity', 'eternal')">
                {{ $t("Bao.eternal_selfie") }}
              </button>
            </div>
          </div>
          <!--eslint-disable-next-line-->
          <p  v-html="kycIdCard" />
        </div>
      </div>
      <div
        class="kyc-item unverified toggle"
        :class="{ active: activeItems['item2'], 'hide-h5': hideAddress }"
      >
        <h5 @click="toggleItem('item2')">
          {{ $t("Bao.kyc_address") }}
        </h5>
        <div class="kyc-content">
          <p>
            {{ $t("Bao.kyc_upload_below") }}
            <span class="highlight">{{ $t("Bao.kyc_oneof") }}</span>
            {{ $t("Bao.kyc_docs") }}
          </p>
          <div class="kyc-ex-pic-frame">
            <img :src="getThemeImagePath('my_kyc_ex2.webp')" alt="">
          </div>
          <div class="kyc-btn-group-frame">
            <div class="btn-frame">
              <button
                class="btn uploadPic JQellipsis"
                @click="setKYCUrl('Address', 'residence')"
              >
                {{ $t("Bao.residence_permit") }}
              </button>
            </div>
            <div class="btn-frame">
              <button
                class="btn uploadPic JQellipsis"
                @click="setKYCUrl('Address', 'utility')"
              >
                {{ $t("Bao.utility_bill") }}
              </button>
            </div>

            <div class="btn-frame">
              <button
                class="btn uploadPic JQellipsis"
                @click="setKYCUrl('Address', 'credit')"
              >
                {{ $t("Bao.credit_bill") }}
              </button>
            </div>
          </div>
          <!--eslint-disable-next-line-->
          <p v-html="kycAddressVerification" />
        </div>
      </div>
      <div class="kyc-item toggle" :class="{ active: activeItems['item3'], 'hide-h5': hideOthers }">
        <h5 @click="toggleItem('item3')">
          {{ $t("Bao.send_additional") }}
        </h5>
        <div class="kyc-content">
          <p> {{ $t("Bao.kyc_additional") }}</p>
          <div class="kyc-btn-group-frame">
            <div class="btn-frame">
              <button
                class="btn uploadPic JQellipsis"
                @click="setKYCUrl('Others', 'none')"
              >
                <span>{{ $t("Bao.select_file_photo") }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="isModalOpen" class="kyc-popup-wrap popup-wrap" :class="{ active: isModalOpen }">
      <div class="popup-box">
        <iframe class="fullscreen-iframe" :src="KYCUrl" @load="iframeLoaded" />
        <a v-if="isIframeLoaded" class="popup-close" @click="closeIframe" />
      </div>
    </div>
  </div>
</template>

<script>
import { KycReview } from '@/api/user'
import { getFullDomain, getThemeImagePath } from '@/utils/tool'
import { page } from '@/api/common'

export default {
  data() {
    return {
      activeItems: {},
      KYCUrl: null,
      KYCVer: process.env.VUE_APP_KYC_VER,
      isModalOpen: false,
      isIframeLoaded: false,
      kycIdCard: '',
      kycAddressVerification: '',
      currentType: null
    }
  },
  computed: {
    memberInfo() {
      return this.$store.state.user.memberInfo
    },
    hideIdentity() {
      return this.shouldHide('Identity')
    },
    hideAddress() {
      return this.shouldHide('Address')
    },
    hideOthers() {
      return this.shouldHide('Others')
    }
  },
  watch: {
    'memberInfo.is_pass_KYC': function(newValue, oldValue) {
      if (newValue === 0) {
        localStorage.removeItem('kycTypes')
      }
    }
  },
  created() {
    page({ type: 'kyc_id_card' }).then(response => {
      this.kycIdCard = response.data.data.content
    }).catch(error => {
      console.error('Failed to fetch kycIdCard:', error)
    })
    page({ type: 'kyc_address_verification' }).then(response => {
      this.kycAddressVerification = response.data.data.content
    }).catch(error => {
      console.error('Failed to fetch kycAddressVerification:', error)
    })
  },
  mounted() {
    window.addEventListener('message', this.receiveMessage, false)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage)
  },
  methods: {
    setKYCUrl(type, subType) {
      this.currentType = type
      this.isIframeLoaded = false
      this.KYCUrl = ''
      const domain = getFullDomain()

      setTimeout(() => {
        this.KYCUrl = `https://script.google.com/macros/s/${this.KYCVer}/exec?brand=${this.memberInfo.brand_id}&promotion=${this.memberInfo.promotion_code}&type=${type}&subtype=${subType}&lang=${this.$store.state.user.language}&domain=${domain}`
      }, 30)
      this.isModalOpen = true
    },
    receiveMessage(event) {
      if (event.data === 'uploadSuccess') {
        // Store the current type in localStorage
        const existingTypes = JSON.parse(localStorage.getItem('kycTypes') || '[]')
        if (!existingTypes.some(item => item.type === this.currentType)) {
          existingTypes.push({ type: this.currentType })
          localStorage.setItem('kycTypes', JSON.stringify(existingTypes))
        }

        KycReview(this.memberInfo.id).then(response => {
          // SET memberInfo.is_pass_KYC from 0 to 2, 未通過 => 審核中
          console.log(response)
        }).catch(error => {
          console.error('Error, KycReview:', error)
        })
      }
    },
    getThemeImagePath,
    shouldHide(type) {
      const existingTypes = JSON.parse(localStorage.getItem('kycTypes') || '[]')
      const typeExists = existingTypes.some(item => item.type === type)
      return this.memberInfo.is_pass_KYC === 2 && typeExists || this.memberInfo.is_pass_KYC === 1
    },
    iframeLoaded() {
      this.isIframeLoaded = true
    },
    toggleItem(index) {
      if (index === 'item1' && this.hideIdentity) return
      if (index === 'item2' && this.hideAddress) return
      if (index === 'item3' && this.hideOthers) return
      this.$set(this.activeItems, index, !this.activeItems[index])
    },
    closeIframe() {
      this.isModalOpen = false
      window.location.reload()
    }
  }
}
</script>

<style scoped>
.popup-box {
  width: 95%;
  max-width: 800px;
  height: 50vh;
}

.fullscreen-iframe {
  width: 100%;
  height: 360px;
  border-radius: 10px;
}

.hide-h5 > h5 {
  background-image:none !important;
}

@media (max-width: 650px){
  .popup-box{
    width: 95%;
    height: 100%;
  }

  .fullscreen-iframe {
    width: 100%;
    height: 80vh;
  }
}

</style>
